import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './aimakeuptransfer/async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default [
  <Route
    key="/business/showcase/gen-ai/ai-makeup-transfer"
    element={<BlankLayout />}
  >
    <Route
      path="business/showcase/gen-ai/ai-makeup-transfer"
      element={<AsyncPage />}
    />
  </Route>,
];
